import React, { useEffect, useState } from 'react';
import twitter from './svg/twitter.svg';
import email from './svg/email.svg';
import close from './svg/x.svg';

const importAll = (r) => {
    let images = {};
    r.keys().map((item) => { return images[item.replace('./', '')] = r(item); });
    return images;
}

const allImages = importAll(require.context('./img', true));
const Images22 = importAll(require.context('./img/2022', true));
const Images23 = importAll(require.context('./img/2023', true));
const Images24 = importAll(require.context('./img/2024', true));
const Images25 = importAll(require.context('./img/2025', true));
const Images26 = importAll(require.context('./img/2026', true));
const cardImages = importAll(require.context('./img', true, /명함/));
const posterImages = importAll(require.context('./img', true, /포스터/));
const designImages = importAll(require.context('./img', true, /도안/));
const logoImages = importAll(require.context('./img', true, /로고,엠블럼/));
const printImages = importAll(require.context('./img', true, /출력물/));
const etcImages = importAll(require.context('./img', true, /기타/));

const menuItems = [
    { id: 1, label: <>전체보기</> },
    { id: 0, label: <>작가 소개</> },
    { id: 2, label: <>단가표</> },
    { id: 3, label: <>연도별</> },
    { id: 4, label: <>종류별</> },
    { id: 5, label: <>연락처</> },
];

function Menu({ menu, changeMenu }) {
    return (
        <div id="menu">
            <button className="menu-title" type="button" onClick={() => changeMenu(1)}>
                NRNR<br />Portfolio
            </button>
            {menuItems.map((item) => (
                <button
                    key={item.id}
                    className={menu === item.id ? 'active' : ''}
                    type="button"
                    onClick={() => changeMenu(item.id)}
                >
                    {item.label}
                </button>
            ))}
        </div >
    )
}

function PopUp({ src, alt }) {
    const [showpop, setshowpop] = useState(false);

    return (
        <div>
            <img src={src} alt={alt} loading="lazy" onClick={() => setshowpop(true)} />
            {showpop && (
                <div className='popupimage'>
                    <div className='shadow' onClick={() => setshowpop(false)}></div>
                    <img className='popupcontent' src={src} alt={alt} loading="lazy" />
                    <img className="popupclose" src={close} alt="닫기" onClick={() => setshowpop(false)} />
                </div>)
            }
        </div>
    );
}

function All() {
    const imageNames = Object.keys(allImages);

    return (
        <div className="main">
            <div style={{ textAlign: "center", margin: "10px 10px 20px 10px" }}>
                <h4>전체 작업물을 보여줍니다. 원하는 기준으로 보고 싶다면 연도별/종류별 메뉴를 이용해주세요.</h4>
            </div>
            <div id="allgallery" className='gallery'>
                {imageNames.map((imageName, index) => {
                    return (
                        <PopUp key={index} src={allImages[imageName]} alt={imageName} />);
                })}
            </div>
        </div>
    );
}

function About() {
    return (
        <div className="main" id="aboutmain">
            <p>디자이너와 방송인을 겸업하고 있는 냐롱냐롱이라고 합니다.</p>
            <p>각종 디자인뿐만 아니라 다양한 출력물에도 대응 가능합니다.</p>
            <p>현재 굿즈 디자인과 출력, 제작에도 경험을 쌓고 있어</p>
            <p>굿즈 디자인을 원하실 경우 출력 상담까지 진행해드리고 있습니다. (별도 상담 필요)</p>
            <p>출력 디자인뿐만 아니라 상업 디자인, 개인 굿즈 디자인도 만들어온 경력이 있으며</p>
            <p>다양한 고객층의 니즈를 맞춰온 만큼  제 디자인을 믿고</p>
            <p>연락주신 분들의 만족도를 맞춰드릴 수 있을 것이라 생각합니다.</p>
            <p>잘부탁드립니다.</p>
            <p>감사합니다.</p>
        </div>
    )
}

function Cost() {
    return (
        <div className="main" id="costmain">
            <table border="2" style={{ borderCollapse: "collapse" }}>
                <colgroup>
                    <col style={{ width: "140px" }} />
                    <col style={{ width: "120px" }} />
                    <col style={{ width: "120px" }} />
                </colgroup>
                <tr style={{ height: "40px", textAlign: "center" }}>
                    <td></td>
                    <td>비상업가</td>
                    <td>상업가</td>
                </tr>
                <tr style={{ height: "40px" }}>
                    <td>&nbsp;디자인 명함&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>40,000&nbsp;</td>
                    <td></td>
                </tr>
                <tr style={{ height: "40px" }}>
                    <td>&nbsp;디자인 로고&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>50,000&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>100,000&nbsp;</td>
                </tr>
                <tr style={{ height: "40px" }}>
                    <td>&nbsp;디자인 엠블럼&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>50,000&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>100,000&nbsp;</td>
                </tr>
                <tr style={{ height: "40px" }}>
                    <td>&nbsp;디자인 포스터&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>30,000&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>60,000&nbsp;</td>
                </tr>
                <tr style={{ height: "40px" }}>
                    <td>&nbsp;디자인 썸네일&nbsp;</td>
                    <td style={{ textAlign: "right" }}><span style={{ float: "left" }}>&nbsp;&#8361;</span>30,000&nbsp;</td>
                    <td></td>
                </tr>
            </table>
            <p>이외 디자인은 문의 주실 경우 일에 따라 금액 책정하여 별도로 안내 드립니다.<br /><br />출력에 대한 안내도 가능하오나 이는 별도 금액이 붙으며,<br />상담과 함께 진행되오니 참고 부탁드립니다.</p>
        </div>
    )
}

function Yearly() {
    const [years, setYear] = useState({ two2: false, two3: false, two4: false, two5: false, two6: false });
    const changeYear = (year) => {
        setYear(years => {
            return {
                ...years, [year]: !years[year],
            }
        });
    };

    return (
        <div className="main">
            <div style={{ marginBottom: "20px" }}>
                <fieldset id="select">
                    <div>
                        <input type="checkbox" checked={years.two2} onChange={() => changeYear('two2')} />
                        <label>
                            2022
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={years.two3} onChange={() => changeYear('two3')} />
                        <label>
                            2023
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={years.two4} onChange={() => changeYear('two4')} />
                        <label>
                            2024
                        </label>
                    </div><div>
                        <input type="checkbox" checked={years.two5} onChange={() => changeYear('two5')} />
                        <label>
                            2025
                        </label>
                    </div><div>
                        <input type="checkbox" checked={years.two6} onChange={() => changeYear('two6')} />
                        <label>
                            2026
                        </label>
                    </div>
                </fieldset>
                <div style={{ textAlign: "center", margin: "10px 10px 20px 10px" }}>
                    <h4>이미지가 보이지 않거나, 로딩이 느리면 선택박스를 껐다가 켜주세요</h4>
                </div>
            </div>
            <div id="yeargallery" className='gallery'>
				{years.two6 && Object.keys(Images26).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={Images26[imageName]} alt={imageName} />);
                })}
                {years.two5 && Object.keys(Images25).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={Images25[imageName]} alt={imageName} />);
                })}
                {years.two4 && Object.keys(Images24).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={Images24[imageName]} alt={imageName} />);
                })}
                {years.two3 && Object.keys(Images23).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={Images23[imageName]} alt={imageName} />);
                })}
                {years.two2 && Object.keys(Images22).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={Images22[imageName]} alt={imageName} />);
                })}
            </div>
        </div>
    )
}

function Type() {
    const [types, setTypes] = useState({ card: false, poster: false, design: false, logo: false, print: false, etc: false });
    const changeTypes = (type) => {
        setTypes(types => {
            return {
                ...types, [type]: !types[type],
            }
        });
    };

    return (
        <div className="main">
            <div style={{ marginBottom: "20px" }}>
                <fieldset id="select">
                    <div>
                        <input type="checkbox" checked={types.card} onChange={() => changeTypes('card')} />
                        <label>
                            명함
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={types.poster} onChange={() => changeTypes('poster')} />
                        <label>
                            포스터
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={types.design} onChange={() => changeTypes('design')} />
                        <label>
                            도안
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={types.logo} onChange={() => changeTypes('logo')} />
                        <label>
                            로고/엠블럼
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={types.print} onChange={() => changeTypes('print')} />
                        <label>
                            출력물
                        </label>
                    </div>
                    <div>
                        <input type="checkbox" checked={types.etc} onChange={() => changeTypes('etc')} />
                        <label>
                            기타
                        </label>
                    </div>
                </fieldset>
                <div style={{ textAlign: "center", margin: "10px 10px 20px 10px" }}>
                    <h4>이미지가 보이지 않거나, 로딩이 느리면 선택박스를 껐다가 켜주세요</h4>
                </div>
            </div>
            <div id="typegallery" className='gallery'>
                {types.card && Object.keys(cardImages).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={cardImages[imageName]} alt={imageName} />);
                })}
                {types.poster && Object.keys(posterImages).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={posterImages[imageName]} alt={imageName} />);
                })}
                {types.design && Object.keys(designImages).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={designImages[imageName]} alt={imageName} />);
                })}
                {types.logo && Object.keys(logoImages).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={logoImages[imageName]} alt={imageName} />);
                })}
                {types.print && Object.keys(printImages).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={printImages[imageName]} alt={imageName} />);
                })}
                {types.etc && Object.keys(etcImages).map((imageName, index) => {
                    return (
                        <PopUp key={index} src={etcImages[imageName]} alt={imageName} />);
                })}
            </div>
        </div>
    )
}

function Contact() {
    return (
        <div className="main" id="contactmain">
            <p>사이트에서의 문의는 현재 트위터 DM과 메일로 받고 있습니다.</p>
            <div style={{ display: "flex" }}>
                <a href="https://twitter.com/NRNR_twitch"><img src={twitter} alt="twitter" style={{ float: "left", width: "60px" }} /></a>
                <p>&nbsp;https://twitter.com/NRNR_twitch</p>
            </div>
            <div style={{ display: "flex" }}>
                <a href="mailto:nrnryt@gmail.com"><img src={email} alt="email" style={{ width: "60px" }} /></a>
                <p>&nbsp;nrnryt@gmail.com</p>
            </div>
            <p>트위터 DM이 확인이 빠르니 참고 부탁드립니다.</p>
        </div>
    )
}

function Page() {
    useEffect(() => {
        const disableRightClick = (e) => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', disableRightClick);

        return () => {
            document.removeEventListener('contextmenu', disableRightClick);
        };
    }, []);

    useEffect(() => {
        const titleElement = document.getElementsByTagName("title")[0];
        titleElement.innerHTML = `NRNR Portfolio`;
    }, []);

    const [menu, setMenu] = useState(0);
    const changeMenu = (num) => {
        setMenu(num)
    }

    switch (menu) {
        case 1:
            return (
                <div id="Page">
                    <Menu menu={menu} changeMenu={changeMenu} />
                    <All />
                </div>
            )
        case 2:
            return (
                <div id="Page">
                    <Menu menu={menu} changeMenu={changeMenu} />
                    <Cost />
                </div>
            )
        case 3:
            return (
                <div id="Page">
                    <Menu menu={menu} changeMenu={changeMenu} />
                    <Yearly />
                </div>
            )
        case 4:
            return (
                <div id="Page">
                    <Menu menu={menu} changeMenu={changeMenu} />
                    <Type />
                </div>
            )
        case 5:
            return (
                <div id="Page">
                    <Menu menu={menu} changeMenu={changeMenu} />
                    <Contact />
                </div>
            )
        default:
            return (
                <div id="Page">
                    <Menu menu={menu} changeMenu={changeMenu} />
                    <About />
                </div>
            )
    }
}

export default Page;
